<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="preAtendimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="instaciado">
                    <div class="modal-header">
                        <h5 class="modal-title">Formulários</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <h3>{{ marcacao.nome_paciente }}</h3>
                            <h5 v-if="marcacao.procedimento">{{ marcacao.procedimento.search }}</h5>
                            <h5 v-if="marcacao.medico">{{ marcacao.medico.search }}</h5>
                        </div>
                        <az-empty-state v-if="!dados || !dados.length" msg="Nenhum questionário disponível para esse procedimento." />

                        <ul class="list-group" v-if="!item">
                            <li class="list-group-item d-flex justify-content-between" v-for="(modelo, imx) in dados" :key="imx">
                                <div class="lead">
                                    {{ modelo.search }}

                                    <a :href="modelo.doc_pre_atend.doc_certificado.arquivo.temporary_url" target="_blank" v-if="modelo.doc_pre_atend && modelo.doc_pre_atend.doc_certificado && modelo.doc_pre_atend.doc_certificado.arquivo" class="ml-2">
                                        <i class="fas fa-file-contract ml-2"></i>
                                    </a>
                                </div>
                                <button type="button" class="btn btn-outline-success btn-sm" 
                                    v-if="modelo.doc_pre_atend.id_documento_pre_atendimento && modelo.doc_pre_atend.fl_preenchido_pelo_paciente && !$store.state.user.medico"
                                    disabled>
                                    <i class="fa fa-check" aria-hidden="true"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary btn-sm" 
                                    v-else-if="modelo.doc_pre_atend.id_documento_pre_atendimento"
                                    @click="item = modelo.doc_pre_atend">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button type="button" class="btn btn-outline-primary btn-sm" 
                                    v-else
                                    @click="incluir(modelo)">
                                    <i class="fas fa-plus"></i>
                                </button>
                            </li>
                        </ul>

                        <template v-if="item">

                            <az-sub-title :title="item.st_titulo" :big="true">
                                {{ item.created_at ? ( $util.getFormatDate(item.created_at.substr(0, 10)) + item.created_at.substr(10, 6) ) : '' }}

                                <span class="ml-2">
                                    <a href="#" @click.prevent="toggle_buscar_proc()" class="card-link">
                                        <i class="fa-solid fa-magnifying-glass-arrow-right" title="Buscar dados de outro atendimento."></i>
                                    </a>
                                </span>
                            </az-sub-title>

                            <buscar-procedimento 
                                ref="busca" 
                                :id_paciente="marcacao.id_paciente" 
                                v-show="buscar_proc"
                                @selecionado="herdar_selecionado" />

                            <formulario 
                                :compact="item.fl_compact"
                                v-model="item.js_conteudo" 
                                v-if="item" 
                                :saved="saved" 
                                mode="fixed"
                                :config="true" />

                            <button type="button" class="btn btn-secondary mt-3" @click="item = null">Voltar</button>

                        </template>

                        <pre v-if="1 == 0">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <div class="mt-1 mr-2" v-if="item">
                            <az-input 
                                type="checkbox-group"
                                label="Imprimir" 
                                v-model="impressao" />
                        </div>
                        <az-audit-log-button model="documentoPreAtendimento" :id="item.id_documento_pre_atendimento" v-if="item && item.id_documento_pre_atendimento" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="item && !item.doc_certificado" @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../util/AzEmptyState.vue';
import Formulario from '../modulos/consultorio/Formulario.vue';
import AzSubmit from '../util/AzSubmit.vue';
import AzSubTitle from '../util/AzSubTitle.vue';
import AzAuditLogButton from '../util/AzAuditLogButton.vue';
import AzInput from '../shared/forms/AzInput.vue';
import BuscarProcedimento from './BuscarProcedimento.vue';

export default {
    data() { 
        return { 
           dados: null,
           instaciado: false, 
           marcacao: null, 
           item: null, 
           saved: true, 
           impressao: false, 
           validade: false, 
           buscar_proc: false, 
        }
    },

    components: { 
        AzEmptyState,
        Formulario, 
        AzSubmit, 
        AzSubTitle,
        AzAuditLogButton, 
        AzInput, 
        BuscarProcedimento, 
    },

    methods: { 
        herdar_selecionado (campos) { 
            this.$utilform.preencher_campos(this.item.js_conteudo, campos)
            this.toggle_buscar_proc();
        },

        toggle_buscar_proc () { 
            this.buscar_proc = !this.buscar_proc;

            if ( this.buscar_proc ) { 
                this.$refs.busca.exibir();
            }
        },

        incluir (modelo) { 
            let valores = {}
            
            this.dados.filter(mod => { 
                return mod.doc_pre_atend.id_documento_pre_atendimento;
            })
            .forEach(mod => { 
                valores = _.merge(valores, this.$utilform.obter_campos(mod.doc_pre_atend.js_conteudo));
            });
            
            modelo.doc_pre_atend.js_conteudo = this.$utilform.preencher_campos(
                modelo.doc_pre_atend.js_conteudo, 
                valores
            );

            this.item = modelo.doc_pre_atend;
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'documentos_pre_atendimento',
                func: 'store',
                dados: this.item,
                modal: 'preAtendimentoModal',
                callback: res => { 
                    if ( this.impressao ) { 
                        console.log(res);
                        //alert('Imprimir...');
                        this.$util.print_preview('imprimir/documentoPreAtendimento/' + res.id_documento_pre_atendimento, true);
                    }

                    this.$emit('refresh');
                }
            });
        },

        abrir (marcacao) { 

            this.item = null;
            this.marcacao = marcacao;
            this.instaciado = true;
            
            this.dados = null;
            this.$store.commit('loading', true);

            $('#preAtendimentoModal').modal('show');

            this.$util.loadItem(this, { 
                service: 'documentos_pre_atendimento', 
                func: 'lista', 
                parms: { 
                    id_marcacao: marcacao.id_marcacao, 
                }
            })
            .then(res => { 
                this.dados = res;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        }
    }
}
</script>